/**
 * Common actions usable with any feature
 */
export const COMMON_ACTIONS = {
  PAGE_ENTERED: 'page_entered',
  PAGE_EXITED: 'page_exited',
  CTA_CLICKED: 'cta_clicked',
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  FORM_SUCCESS: 'form_success',
  FORM_FAILED: 'form_failed',
  FORM_ABANDONED: 'form_abandoned',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  ERROR: 'error',
  TAB_CHANGED: 'tab_changed',
  MODAL_OPENED: 'modal_opened',
  MODAL_CLOSED: 'modal_closed',
} as const;
